import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Error } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    padding: "8px",
    maxWidth: "350px",
    width: "95%",
    margin: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "8px 4px",
  },
  icon: {
    fontSize: "24px",
    color: "#D32F2F",
    marginBottom: "20px",
  },
  title: {
    fontFamily: "Nunito",
    fontWeight: "700",
    fontSize: "14px",
    color: "#1A1F36",
    marginBottom: "20px",
  },
  description: {
    fontFamily: "Nunito",
    fontSize: "14px",
    fontWeight: "400",
    color: "#4F5B76",
    lineHeight: "1.4",
    marginBottom: "20px",
  },
  deleteButton: {
    fontFamily: "Nunito",
    backgroundColor: "#D32F2F",
    color: "#FFFFFF",
    width: "100%",
    height: "38px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "13px",
    marginBottom: "10px",
    "&:hover": {
      backgroundColor: "#B71C1C",
    },
  },
  cancelButton: {
    fontFamily: "Nunito",
    color: "#1A73E8",
    width: "100%",
    height: "34px",
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "13px",
    "&:hover": {
      backgroundColor: "rgba(26, 115, 232, 0.04)",
    },
  },
}));

const ReportDeleteConfirmDialogMobile = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      aria-labelledby="delete-confirm-dialog-title-mobile"
    >
      <DialogContent style={{ padding: "12px" }}>
        <Box className={classes.container}>
          <Error className={classes.icon} />
          <Typography
            className={classes.title}
            id="delete-confirm-dialog-title-mobile"
          >
            Delete {selectedCount} {selectedCount === 1 ? "Report" : "Reports"}?
          </Typography>
          <Typography className={classes.description}>
            This action cannot be undone. The selected{" "}
            {selectedCount === 1 ? "report" : "reports"} will be permanently
            removed.
          </Typography>
          <Button
            className={classes.deleteButton}
            variant="contained"
            onClick={onConfirm}
          >
            Delete
          </Button>
          <Button className={classes.cancelButton} onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportDeleteConfirmDialogMobile;
